<template>
    <div id="form-detail">
        <div v-if="loading">
            <p>Loading...</p>
        </div>
        <div v-else-if="form.form">
            <div class="header">
                <div class="icon-container">
                    <i class="md-icon">settings</i>
                </div>
                <div class="text-container">
                    <div class="title">{{ $t("form.formSettings.formSettings") }}</div>
                    <div class="description">{{ $t("form.formSettings.changeFormStateAndProperties") }}</div>
                </div>
            </div>
            <div class="content">
                <div class="form-group">
                    <label class="form-title">{{ $t("form.formSettings.title") }}</label>
                    <input
                        type="text"
                        id="form-title"
                        :placeholder="$t('form.formSettings.enterNameForm')"
                        v-model="form.form.title"
                        @input="debouncedUpdateFormTitle"
                    />
                </div>
                <hr>
<!--                bu kısım yapılınca açılacak-->
<!--                <div class="form-group">-->
<!--                    <div style="display: grid;">-->
<!--                        <label class="form-title">{{ $t("form.formSettings.formStatus") }}</label>-->
<!--                        <label class="subTitle">{{ $t("form.formSettings.activateOrDeactivate") }}</label>-->
<!--                        <div class="form-settings-card" @click="toggleSituationModal" style="opacity: 0.5;">-->
<!--                            <div class="icon-section">-->
<!--                                <i class="md-icon">open_in_new</i>-->
<!--                            </div>-->
<!--                            <div class="text-section">-->
<!--                                <div class="title">{{ $t("form.formSettings.effective") }}</div>-->
<!--                                <div class="description">{{ $t("form.formSettings.yourFromIsVisible") }}-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="arrow-section">-->
<!--                                <i class="md-icon">chevron_right</i>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
                <a-modal
                    id="situation-modal"
                    :width="700"
                    :visible="situationModal"
                    :footer="null"
                    :header="null"
                    @ok="toggleSituationModal"
                    @cancel="toggleSituationModal"
                >
                    <div class="modal-detail">
                        <div class="modal-header-detail">
                            <div class="icon-container">
                                <i class="md-icon">assignment</i>
                            </div>
                            <h3>{{ $t('form.formSettings.formStatus') }}</h3>
                        </div>
                        <p>{{ $t('form.formSettings.selectStatusForm') }}</p>
                        <div class="form-group">
                            <label for="form-status">{{ $t('form.formSettings.formStatus') }}</label>
                            <a-space>
                                <a-select id="form-status" v-model="formStatus" style="width: 630px;">
                                    <a-select-option value="one">{{ $t('form.formSettings.effective') }}</a-select-option>
                                    <a-select-option value="two">{{ $t('form.formSettings.disabled') }}</a-select-option>
                                    <a-select-option value="three">{{ $t('form.formSettings.disableSpecifiedTime') }}
                                    </a-select-option>
                                    <a-select-option value="four">{{ $t('form.formSettings.disableFormResponse') }}
                                    </a-select-option>
                                    <a-select-option value="five">{{ $t('form.formSettings.pageShownAfterForm') }}
                                    </a-select-option>
                                </a-select>
                            </a-space>
                        </div>
                        <div class="button-group">
                            <button @click="toggleSituationModal" class="btn-cancel">{{ $t("message.cancel") }}</button>
                            <button @click="toggleSituationModal" class="btn-save">{{ $t("message.save") }}</button>
                        </div>
                    </div>
                </a-modal>
            </div>
        </div>
        <div v-else>
            <p>{{ $t("form.formSettings.formNotFound") }}</p>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import { debounce } from "lodash";

export default {
    name: "FormDetail",
    props: {
        formId: {
            type: String,
            required: true,
        },
        siteId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            form: {},
            loading: false,
            error: null,
            success: null,
            situationModal: false,
            formStatus: this.$t('form.formSettings.effective'),
        };
    },
    mounted() {
        this.loadForm();
        this.debouncedUpdateFormTitle = debounce(this.updateFormTitle, 1000);
    },
    methods: {
        ...mapActions({
            getFormById: "forms/getFormById",
            updateFormData: "forms/updateFormData",
        }),
        toggleSituationModal() {
            // arka plan hazırlana kadar kapalı kalıcak
            // this.situationModal = !this.situationModal;
        },
        async loadForm() {
            this.loading = true;
            this.error = null;
            try {
                const response = await this.getFormById({ siteId: this.siteId, formId: this.formId });
                this.form = response;
                this.loading = false;
            } catch (error) {
                this.error = this.$t("form.formSettings.errorLoadingform");
                this.loading = false;
                console.error(this.$t("form.formSettings.errorLoadingform"), error);
            }
        },
        async updateFormTitle() {
            this.error = null;
            this.success = null;
            const { siteId, formId } = this;
            const formData = {
                title: this.form.form.title,
            };
            try {
                await this.updateFormData({ siteId, formId, formData });
                this.success = this.$t("form.formSettings.formUpdated");
                this.$message.success(this.$t("form.formSettings.formUpdated"));
            } catch (error) {
                this.error = this.$t("form.formSettings.formErrorUpdated");
                this.$message.error(this.$t("form.formSettings.formErrorUpdated"));
            }
        },
    },
    watch: {
        'form.form.title'(newVal, oldVal) {
            this.debouncedUpdateFormTitle();
        },
    },
};
</script>

<style lang="scss">
#form-detail {
    display: grid;
    justify-content: center;
    padding: 2rem;
    font-family: 'Roboto', sans-serif;

    .header {
        display: flex;
        align-items: center;
        background-color: #f7f7f7;
        padding: 1rem;
        border-radius: 8px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        margin-bottom: 1.5rem;
        width: 700px;

        .icon-container {
            background-color: #ff9830;
            border-radius: 8px;
            padding: 0.5rem;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 1rem;

            i {
                color: #fff;
                font-size: 2rem;
            }
        }

        .text-container {
            .title {
                font-weight: bold;
                font-size: 1.5rem;
                color: #002855;
            }

            .description {
                font-size: 1rem;
                color: #666;
            }
        }
    }

    .content {
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        width: 100%;
        max-width: 700px;

        .form-group {
            padding: 2rem;

            .form-title {
                font-size: 1.5rem;
                font-weight: bold;
                color: #596066;
            }

            .subTitle {
                font-size: 1rem;
                font-weight: bold;
                color: #596066;
            }

            input[type="text"] {
                width: 100%;
                padding: 0.75rem;
                border: 1px solid #ddd;
                border-radius: 4px;
                font-size: 1rem;
                color: #333;
            }

            .form-settings-card {
                display: flex;
                align-items: center;
                background-color: #fff;
                border: 1px solid #dcdcdc;
                border-radius: 8px;
                padding: 1rem;
                width: 100%;
                max-width: 700px;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                transition: box-shadow 0.3s;
                border-left: 5px solid #78bb07;
                cursor: pointer;

                .icon-section {
                    background-color: #78bb07;
                    padding: 1rem;
                    border-radius: 8px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-right: 1rem;

                    i {
                        color: #fff;
                        font-size: 2rem;
                    }
                }

                .text-section {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    .title {
                        font-weight: bold;
                        font-size: 1.25rem;
                        color: #78bb07;
                    }

                    .description {
                        font-size: 1rem;
                        color: #666;
                    }
                }

                .arrow-section {
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    i {
                        font-size: 1.5rem;
                        color: #666;
                    }
                }
            }
        }
    }
}

#situation-modal {
    .modal-detail {
        background-color: transparent;
        padding: 16px;
        width: 100%;

        .modal-header-detail {
            display: flex;
            align-items: center;
            margin-bottom: 16px;

            .icon-container {
                background-color: #4285f4;
                border-radius: 50%;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 40px;
                height: 40px;
                margin-right: 8px;
            }

            .md-icon {
                font-size: 24px;
            }

            h3 {
                margin: 0;
                font-size: 18px;
                font-weight: 500;
            }
        }

        p {
            margin: 8px 0;
            font-size: 14px;
            color: #666;
        }

        .form-group {
            margin-bottom: 16px;

            label {
                display: block;
                margin-bottom: 4px;
                font-weight: 500;
            }

            select {
                width: 100%;
                padding: 8px;
                border: 1px solid #ccc;
                border-radius: 4px;
            }
        }

        .button-group {
            display: flex;
            justify-content: space-between;

            button {
                padding: 8px 16px;
                border: none;
                border-radius: 4px;
                font-size: 14px;
                cursor: pointer;

                &.btn-cancel {
                    background-color: #e0e0e0;
                    color: #333;
                }

                &.btn-save {
                    background-color: #7cb342;
                    color: #fff;
                }
            }
        }
    }
}
</style>
